import httclient from 'axios'
import queryString from 'query-string'

const axios = httclient.create({
  timeout: 1800000
})
// localStorage.getItem('token')

// Add a request interceptor
axios.interceptors.request.use(function (config) {
  config.headers.authorization = localStorage.getItem('token')
  config.headers['User-Agent'] = 'OFFICE_ADDIN'
  return config
}, function (error) {
  return Promise.reject(error)
})

const BASE = process.env.BASE_URL

export default function HttpService (endpoint) {
  this.url = `${BASE}${endpoint}`
  this.get = async function (id, query) {
    if (id) {
      return axios.get(`${this.url}/${id}`)
    }
    if (query) {
      const str = queryString.stringify(query)
      const concanatedUrl = `${this.url}?${str}`
      console.log(concanatedUrl)
      return axios.get(`${this.url}?${str}`)
    }
    return axios.get(this.url)
  }
  this.post = async function (body = {}) {
    return axios.post(this.url, body)
  }
  this.put = async function (body = {}) {
    return axios.put(this.url, body)
  }
  this.delete = async function () {
    return axios.delete(this.url)
  }
  this.patch = async function (body = {}) {
    return axios.patch(this.url, body)
  }
}



// WEBPACK FOOTER //
// ./src/service/httpservice.js